// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_oj-0";
export var buttonContainer = "_oj-3";
export var cancelButton = "_oj-4";
export var headerSection = "_oj-6";
export var headerTitle = "_oj-9";
export var messageSideLeft = "_oj-1";
export var messageSideRight = "_oj-2";
export var orderNumberContainer = "_oj-7";
export var orderNumberLabel = "_oj-8";
export var submitButton = "_oj-5";